/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./products-and-services.vue?vue&type=template&id=19f2be86&"
import script from "./products-and-services.vue?vue&type=script&lang=js&"
export * from "./products-and-services.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./products-and-services.vue?vue&type=style&index=0&id=19f2be86&prod&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports